/* 帳號是否於 oneClub */
export const getCheckOneClubId = async (account) => {
  const response = await fetch(`${process.env.REACT_APP_ELECTRONIC_COMMERCE_API_DOMAIN}/services/${account}`);
  return await response.json();
};